import React, { Component, Fragment } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { deleteEmployeeRedux } from "../../../actions/index";
import { connect } from "react-redux";
import { confirmDialog } from "../../common/ConfirmDialog";

export class Datatable extends Component {
  render() {
    const { myData, history, startToggleModal } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="em-table-wrap">
          <table className="table em-table">
            <thead>
              <tr>
                <th scope="col">Admin Id</th>
                <th scope="col">Name</th>
                <th scope="col">Designation</th>
                <th scope="col">Address</th>
                <th scope="col">Status</th>
                <th scope="col" className="em-col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={6} className="em-empty">
                    No employees yet.
                  </td>
                </tr>
              ) : (
                rows.map((employee, i) => (
                  <tr key={i}>
                    <td>{employee.adminId}</td>
                    <td>{employee.name}</td>
                    <td>{employee.designation}</td>
                    <td>{employee.address}</td>
                    <td>
                      <span
                        className={`em-badge ${
                          employee.status === "Active" ? "em-badge--active" : "em-badge--deactive"
                        }`}
                      >
                        {employee.status}
                      </span>
                    </td>
                    <td className="em-col-action">
                      <button
                        type="button"
                        className="em-icon-btn em-icon-btn--edit"
                        onClick={() => startToggleModal(employee)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                      <button
                        type="button"
                        className="em-icon-btn em-icon-btn--delete"
                        onClick={async () => {
                          if (
                            await confirmDialog(
                              "Are you sure you wish to delete this employee?"
                            )
                          ) {
                            this.props.deleteEmployeeRedux(employee.name);
                            toast.success("Successfully Deleted !");
                          }
                        }}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                      <button
                        type="button"
                        className="em-icon-btn em-icon-btn--view"
                        onClick={() => {
                          history.push(`/expense/employee/${employee.name}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default connect(null, { deleteEmployeeRedux })(Datatable);
